import { Injectable } from '@angular/core';
import { ShipmentTransportOrderEndpoint } from '../../shipment-transport-order/constants';
import { ShipmentWaybillEndpoint } from '../constants';
import { WaybillIdView } from '../../../models';
import { WrapperHttpService } from '../../../services/wrapper-http-service';
import { API_URL } from '../../../../services/config';
import { getQueryStringFromObject } from '../../../../common/utils';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ShipmentWaybillItemService {
  constructor(private http: WrapperHttpService) {}

  getShipmentWaybillCustomsDocumentsCount(waybillIdView: WaybillIdView): Observable<number> {
    const url = `${API_URL}${ShipmentWaybillEndpoint.Base}${ShipmentWaybillEndpoint.Waybills}${
      ShipmentWaybillEndpoint.CustomsDocuments
    }${ShipmentWaybillEndpoint.Count}?${getQueryStringFromObject({
      ...waybillIdView,
    })}`;

    return this.http.withLoading().get(url);
  }

  getNotificationListCount(waybillIdView: WaybillIdView): Observable<number> {
    return this.http
      .withLoading()
      .get(
        `${API_URL}${ShipmentWaybillEndpoint.Base}${ShipmentWaybillEndpoint.Waybills}${
          ShipmentTransportOrderEndpoint.Notifications
        }${ShipmentTransportOrderEndpoint.Count}?${getQueryStringFromObject<WaybillIdView>(waybillIdView)}`,
      );
  }

  getShipmentWaybillDemurrageAndDetentionTabAvailability(waybillInternalId: string): Observable<boolean> {
    return this.http
      .withLoading()
      .get(
        `${API_URL}${ShipmentWaybillEndpoint.Base}${ShipmentWaybillEndpoint.Waybills}${
          ShipmentWaybillEndpoint.ContainerCharges
        }${ShipmentWaybillEndpoint.Available}?${getQueryStringFromObject({ waybillInternalId })}`,
      );
  }
}
